import { ApiProjectType } from "@incendium/api";
import useProjectSettings from "../hooks/useProjectSettings";

const useHasProjectType = () => {
  const { hasProjectType } = useProjectSettings();
  return (type: ApiProjectType) => hasProjectType(type);
};

export default useHasProjectType;


